export default "__VITE_ASSET__Bv_m0lOE__"